export default [
  {
    name: 'UK',
    url: 'http://www.watchfooty.co.uk',
    image: '../../../../../../images/uk.png',
    lang: 'en',
  },
  {
    name: 'Denmark',
    url: 'https://www.sesport.dk/',
    image: '../../../../../../images/denmark.png',
    lang: 'da',
  },
  {
    name: 'Netherlands',
    url: 'https://www.bekijksport.nl/',
    image: '../../../../../../images/dutch.png',
    lang: 'nl',
  },
];
